import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";
import { showToastr } from "@shared/common";
import { ToastrService } from "ngx-toastr";
import { VerificateService } from "./verificate.service";

@Component({
  selector: "verificate",
  templateUrl: "verificate.component.html",
  styleUrls: ["verificate.component.scss"],
  providers: [VerificateService],
})
export class VerificateComponent implements AfterViewInit {
  @ViewChild("inputBusqueda", { static: false })
  inputBusqueda: ElementRef;

  numerodoc = "";
  esCodigo = false;

  constructor(
    public service: VerificateService,
    private toastr: ToastrService
  ) {
    window.scrollTo({ top: 0 });
  }

  buscar() {
    if (![9, 11, 8].includes(`${this.numerodoc}`.trim().length)) {
      showToastr(this.toastr, `Cédula invalida.`, "error");
      return;
    }

    this.service.verificarStatus(`${this.numerodoc}`, (value) => {
      if(value){
        this.numerodoc = "";
        this.clickInputBusqueda();
      }
    });
  }

  ngAfterViewInit() {
    this.clickInputBusqueda();
  }

  limpiarDatos() {
    this.service.model = {};
    this.numerodoc = "";
    this.clickInputBusqueda();
  }

  clickInputBusqueda() {
    setTimeout(() => {
      this.inputBusqueda.nativeElement.focus();
    });
  }
}
